<template>
  <div v-if="esAdministrador">
    <v-app-bar app clipped-left color="primary">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <img
        class="logotype"
        src="https://media-exp1.licdn.com/dms/image/C4D0BAQHwA_tsSXdx_g/company-logo_200_200/0/1601511032975?e=2147483647&v=beta&t=OICffYwpNaMSyuZzQrG2eje1yPZqNWxlkEHaBi8kIpk"
      />
      <v-toolbar-title class="easy-title">Easy Rent</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="salir()" icon v-if="logueado">
        <v-icon>logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app clipped color="grey darken-3">
      <v-list dense>
        <!-- <v-list-item :to="{ name: 'home' }">
          <v-list-item-content>
            <v-list-item-avatar>
              <img src="https://media-exp1.licdn.com/dms/image/C4D0BAQHwA_tsSXdx_g/company-logo_200_200/0/1601511032975?e=2147483647&v=beta&t=OICffYwpNaMSyuZzQrG2eje1yPZqNWxlkEHaBi8kIpk" />
            </v-list-item-avatar>
          </v-list-item-content>
        </v-list-item> -->
        <!-- Empresa -->
        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Empresa</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>storage</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Datos de empresa</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>business</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Oficinas</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'tareas' }">
              <v-list-item-action>
                <v-icon dark>speaker_notes</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Tareas</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <!-- Coches -->
        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Coches</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'coches' }">
              <v-list-item-action>
                <v-icon dark>directions_car</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Coches</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'grupos' }">
              <v-list-item-action>
                <v-icon dark>group_work</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Grupos</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'tarifas' }">
              <v-list-item-action>
                <v-icon dark>monetization_on</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Tarifas</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>crop_free</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Disponibilidad</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'extras' }">
              <v-list-item-action>
                <v-icon dark>widgets</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Extras</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>security</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Seguros</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <!-- Servicios -->
        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Servicios</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>verified_user</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >ITV</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>check_circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Revisión completa</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>check</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Revisión básica y limpieza</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>battery_alert</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Batería</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>disc_full</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Neumáticos</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>stop</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Frenos</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <!-- Alquileres -->
        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Alquileres</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'reservas' }">
              <v-list-item-action>
                <v-icon dark>date_range</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Reservas</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>assignment</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Contratos</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>event_note</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Facturas</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
        <!-- Perfiles -->
        <template>
          <v-list-group>
            <v-list-item slot="activator">
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Perfiles</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'clientes' }">
              <v-list-item-action>
                <v-icon dark>assignment_ind</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Clientes</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>group_work</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Colaboradores</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>ev_station</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Proveedores</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: 'usuario' }">
              <v-list-item-action>
                <v-icon dark>people</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Usuarios</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item :to="{ name: '' }">
              <v-list-item-action>
                <v-icon dark>account_circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="white--text pt-2"
                  >Mi perfil</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {
    source: String,
  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    ...mapState("usuarioNamespace", ["usuario"]),
    logueado() {
      return this.usuario;
    },
    esAdministrador() {
      return this.usuario && this.usuario.rol == "Administrador";
    },
  },
  methods: {
    ...mapActions("usuarioNamespace", ["salir"]),
  },
  // created() {
  //   this.$vuetify.theme.dark = true;
  // },
};
</script>
<style>
.logotype {
  width: 40px;
  margin-right: 5px;
  margin-left: 5px;
}
.easy-title {
  font-weight: 400;
}
</style>
